import { i18n } from '@/utils/i18n'

export const appName = () => i18n.global.t('app.name')
export const appDescription = () => i18n.global.t('app.description')
